import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { ConfluencePageAri } from '@atlassian/ari';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

import { AutomationRovoButton } from './automation-rovo-button/AutomationRovoButton';

const i18n = defineMessages({
	rovoButtonTitle: {
		id: 'automation-menu.page-rovo-button-menu.title',
		defaultMessage: 'Page automations',
		description: 'The title of the page automation in rovo button header.',
	},
});

export type PageAutomationRovoButtonProps = {
	spaceKey: string;
	pageId: string;
	contentTitle: string;
};

export const PageAutomationRovoButton = ({
	pageId,
	spaceKey,
	contentTitle,
}: PageAutomationRovoButtonProps) => {
	const { cloudId } = useSessionData();
	const { formatMessage } = useIntl();
	const pageAri = ConfluencePageAri.create({ siteId: cloudId, pageId });

	return (
		<ErrorBoundary attribution={Attribution.AUTOMATION_FOR_CONFLUENCE}>
			<AutomationRovoButton
				spaceKey={spaceKey}
				aris={[pageAri]}
				analyticsSource="pageRovoButtonManualTriggers"
				title={formatMessage(i18n.rovoButtonTitle)}
				contentTitle={contentTitle ?? ''}
			/>
		</ErrorBoundary>
	);
};
